import MobileFeaturePage from 'components/features-page/MobileFeaturePage'
import type { PageProps } from 'gatsby'

export default function Android({ location }: PageProps): JSX.Element {
  return <MobileFeaturePage path={location.pathname} />
}
